import axiosConfig from '../utils/axiosConfigInstance';

export const onboardingV2Api = {
    // Step 1: Create Profile
    createProfile: async (profileData) => {
        return await axiosConfig.post(
            `${import.meta.env.VITE_APP_API_URL}/onboarding/v2/create-profile`,
            profileData
        );
    },

    // Step 2: Create Subscription with Card
    createSubscription: async (paymentData) => {
        return await axiosConfig.post(
            `${import.meta.env.VITE_APP_API_URL}/onboarding/v2/create-subscription`,
            paymentData
        );
    },

    // Update onboarding data (steps 1-6)
    updateOnboardingData: async (data) => {
        return await axiosConfig.patch(
            `${import.meta.env.VITE_APP_API_URL}/onboarding/v2/update-data`,
            data
        );
    },

    // Get current user's onboarding role
    getOnboardingRole: async () => {
        return await axiosConfig.get(
            `${import.meta.env.VITE_APP_API_URL}/onboarding/v2/role`
        );
    },

    // Complete onboarding
    completeOnboarding: async () => {
        return await axiosConfig.patch(
            `${import.meta.env.VITE_APP_API_URL}/onboarding/v2/complete`
        );
    },

    // Dismiss onboarding
    dismissOnboarding: async () => {
        return await axiosConfig.patch(
            `${import.meta.env.VITE_APP_API_URL}/onboarding/v2/dismiss`
        );
    },

    // Get recommended videos for onboarding
    getRecommendedVideos: async () => {
        return await axiosConfig.get(
            `${import.meta.env.VITE_APP_API_URL}/onboarding/v2/recommended-videos`
        );
    },

    // Save recommended videos as playlist
    saveRecommendedAsPlaylist: async (data) => {
        return await axiosConfig.post(
            `${import.meta.env.VITE_APP_API_URL}/onboarding/v2/save-recommended-playlist`,
            data
        );
    },

    // Save recommendation feedback (yes/no)
    saveRecommendationFeedback: async (helpful) => {
        return await axiosConfig.post(
            `${import.meta.env.VITE_APP_API_URL}/onboarding/v2/recommendation-feedback`,
            { helpful }
        );
    },

    
    // Create payment intent for Apple Pay
    createPaymentIntent: async (data) => {
        return await axiosConfig.post(
            `${import.meta.env.VITE_APP_API_URL}/chargebee/create-payment-intent`,
            data
        );
    },

    // Create subscription with payment intent (for Apple Pay)
    createSubscriptionWithPaymentIntent: async (data) => {
        return await axiosConfig.post(
            `${import.meta.env.VITE_APP_API_URL}/chargebee/create-subscription-with-payment-intent`,
            data
        );
    },

    // Validate coupon code
    validateCoupon: async (couponCode, planId) => {
        return await axiosConfig.post(
            `${import.meta.env.VITE_APP_API_URL}/onboarding/v2/coupon/validate`,
            { couponCode, planId }
        );
    },

    // Estimate price with coupon
    estimatePrice: async (planId, couponId) => {
        return await axiosConfig.post(
            `${import.meta.env.VITE_APP_API_URL}/onboarding/v2/coupon/estimate`,
            { planId, couponId }
        );
    }
};
